import { render } from "./OurSpecialties.vue?vue&type=template&id=a8cfec54"
import script from "./OurSpecialties.vue?vue&type=script&lang=js"
export * from "./OurSpecialties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__